import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, FormControl, InputLabel, Select, MenuItem, Box, CircularProgress, FormHelperText } from '@mui/material';

const SubjectForm = ({ open, onClose, onSubmit, initialData, title = 'Add Subject', loading, classes = [], teachers = [] }) => {
  const [formData, setFormData] = useState({
    name: '',
    class_id: '',
    teacher_id: '',
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.name || '',
        class_id: initialData.class_id || '',
        teacher_id: initialData.teacher_id || '',
      });
    } else {
      setFormData({ name: '', class_id: '', teacher_id: '' });
    }
    setErrors({});
  }, [initialData]);

  const handleChange = (field) => (e) => {
    const value = e.target.value;
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors(prev => ({ ...prev, [field]: '' }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.class_id) newErrors.class_id = 'Class is required';
    if (!formData.teacher_id) newErrors.teacher_id = 'Teacher is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    const payload = { ...formData };
    if (initialData?.id) payload.id = initialData.id;
    await onSubmit(payload);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Box component="form" sx={{ mt: 1 }}>
          <TextField
            fullWidth
            margin="normal"
            label="Subject Name"
            value={formData.name}
            onChange={handleChange('name')}
            error={!!errors.name}
            helperText={errors.name}
            required
          />

          <FormControl fullWidth margin="normal" error={!!errors.class_id}>
            <InputLabel>Class</InputLabel>
            <Select value={formData.class_id} onChange={handleChange('class_id')} label="Class">
              {classes.map((cls) => (
                <MenuItem key={cls.id} value={cls.id}>{cls.name}{cls.section ? ` - ${cls.section}` : ''}</MenuItem>
              ))}
            </Select>
            {errors.class_id && <FormHelperText>{errors.class_id}</FormHelperText>}
          </FormControl>

          <FormControl fullWidth margin="normal" error={!!errors.teacher_id}>
            <InputLabel>Teacher</InputLabel>
            <Select value={formData.teacher_id} onChange={handleChange('teacher_id')} label="Teacher">
              {teachers.map((t) => (
                <MenuItem key={t.id} value={t.id}>{t.full_name}</MenuItem>
              ))}
            </Select>
            {errors.teacher_id && <FormHelperText>{errors.teacher_id}</FormHelperText>}
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={loading}>
          {loading && <CircularProgress size={20} sx={{ mr: 1, color: 'grey.500' }} />}
          {loading ? (initialData?.id ? 'Updating...' : 'Creating...') : (initialData?.id ? 'Update' : 'Create')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubjectForm;


